import { render } from "./fundManagement.vue?vue&type=template&id=23087400&scoped=true"
import script from "./fundManagement.vue?vue&type=script&lang=js"
export * from "./fundManagement.vue?vue&type=script&lang=js"

import "./fundManagement.vue?vue&type=style&index=0&id=23087400&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23087400"]])

export default __exports__